import React from 'react';
import customTheme from '@/constants/theme.custom';

interface FooterFillSvgProps {
  fill?: string;
}

const FooterFillSvg: React.FC<FooterFillSvgProps> = ({ fill = customTheme.colors.darkBlue }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="auto"
      viewBox="0 0 1440 314"
      preserveAspectRatio="none"
      style={{ display: 'block' }}
    >
      <path
        d="M17.1 263.999L0 252.111V912H1440V0L1423 28.7776C1406 46.5553 1371.4 142.111 1337 136.222C1303 129.888 1268.6 193.222 1234 204.667C1200 216.555 1165.7 177.666 1131 201.332C1097 225.443 1069.31 204.088 1025.35 218.44C983.673 234.08 964.752 215.188 926 243.585C891 273.251 857.1 273.251 823 225.807C789 178.807 754.3 75.4437 720 69.8882C686 64.3327 651.4 176.554 617 194.665C583 212.11 548.6 165.443 514 153.221C480 140.999 445.7 165.443 411 147.332C377 129.888 342.9 249.888 309 250.222C274 249.888 240 189.888 206 213.221C171 236.554 137.1 335.443 103 317.332C69 299.888 34.3 275.444 17.1 263.999Z"
        fill={fill}
      />
    </svg>
  );
};

export default FooterFillSvg;
